import { createRootRoute, Outlet } from "@tanstack/react-router";

import UpdateScreen from "~/components/miscellaneous/update-screen";
import { TouchProvider } from "~/components/ui/hybrid-tooltip";
import { TooltipProvider } from "~/components/ui/tooltip";
import { AuthProvider } from "~/providers/auth-provider";
import { PlatformProvider } from "~/providers/platform-provider";
import { ThemeProvider } from "~/providers/theme-provider";
import { TRPCProvider } from "~/providers/trpc-provider";

export const Route = createRootRoute({
  component: RootComponent,
  head: () => ({
    meta: [
      {
        name: "robots",
        content: "noindex, nofollow",
      },
    ],
  }),
});

function RootComponent() {
  return (
    <PlatformProvider>
      <TRPCProvider>
        <AuthProvider>
          <ThemeProvider storageKey="ui-appearance">
            <TooltipProvider delayDuration={0}>
              <TouchProvider>
                <UpdateScreen />
                <Outlet />
              </TouchProvider>
            </TooltipProvider>
          </ThemeProvider>
        </AuthProvider>
      </TRPCProvider>
      {/* {env.VITE_BRANCH !== "production" && (
        <TanStackRouterDevtools position="bottom-right" />
      )} */}
    </PlatformProvider>
  );
}
